import React, { useRef } from 'react';
import { FaGlobe, FaHeadset, FaRocket, FaShieldAlt, FaTags } from 'react-icons/fa';
import { IoGameController } from 'react-icons/io5';
import { motion, useInView } from 'framer-motion';

const Features = () => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, amount: 0.3 }); // Only animate once when 30% visible

    const features = [
        {
            icon: <FaHeadset size={28} />,
            title: "24/7 Customer Support",
            desc: "Our helpful support staff can provide you with immediate assistance wherever, at any time. We are everytime there to help you have a excellent gaming experience.",
        },
        {
            icon: <IoGameController size={28} />,
            title: "Wide Games Library",
            desc: "Discover a huge selection of games that are accessible on several platforms, ranging from well-known blockbuster titles to obscure independent gems.",
        },
        {
            icon: <FaRocket size={22} />,
            title: "Fast & Easy Checkout",
            desc: "There are few steps and that are also very easy for checkout process, you can purchase your favorite games.",
        },
        {
            icon: <FaTags size={28} />,
            title: "Best Deals & Discounts",
            desc: "Take advantage of seasonal sales and steep savings on popular titles.",
        },
        {
            icon: <FaShieldAlt size={28} />,
            title: "Secure Payments",
            desc: "Every transaction is completely safe and encrypted.",
        },
        {
            icon: <FaGlobe size={28} />,
            title: "Global Access",
            desc: "Get immediate access to our platform and shop for games from anywhere at any time.",
        },
    ];

    return (
        <section ref={ref} className=" text-white py-6 md:py-16">
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                className="max-w-[100%] md:max-w-[80%] mx-auto px-4"
            >
                <h2 className="text-lg md:text-4xl text-center md:text-left font-extrabold mb-12">
                    Level Up Your <br /> Gaming Shopping
                </h2>
                <div className="grid gap-6 md600:grid-cols-2 lg:grid-cols-3">
                    {features.map((feature, idx) => (
                        <div
                            key={idx}
                            className="group rounded-lg p-[1px] bg-gradient-to-r from-purple-500 via-pink-500 to-blue-500 bg-[length:200%_200%] animate-gradient-x transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg hover:shadow-purple-500/20"
                        >
                            <div className="bg-neutral-900 p-6 rounded-lg h-full">
                                <div className="flex items-center justify-center w-12 h-12 rounded-full mb-4 bg-primary transition-transform duration-300 group-hover:scale-110">
                                    {feature.icon}
                                </div>
                                <h3 className="text-lg font-bold mb-2">{feature.title}</h3>
                                <p className="text-sm text-gray-400 mb-4">{feature.desc}</p>
                                {/* <button className="text-sm text-white underline underline-offset-4 flex items-center gap-1 hover:text-purple-400 transition-transform duration-300 group-hover:translate-x-1">
                                    Shop Now →
                                </button> */}
                            </div>
                        </div>
                    ))}
                </div>
            </motion.div>
        </section>
    )
}

export default Features
